import { createSelector } from "@ngrx/store";

import { AppState } from "../store";
import { LoaderState } from ".";

const feature = (state: AppState) => state.loader;

export const loaderSelector = createSelector(
  feature,
  (state: LoaderState) => state.loader
);
